import { useRouter } from 'next/router';

export const usePathname = () => {
  const { pathname } = useRouter();

  return pathname;
};
